import React, {useEffect, useState} from 'react';
import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import { getService, getSite } from '../tools/fetcher';
import Button from './Button';

export default function Service({ className }) {
    const [services, setServices] = useState([]);
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    useEffect(() => {
        getService().then((result) => {
            if (!result?.code) {
                const dt = result.map((d) => ({
                    title: d?.title?.rendered,
                    description: d?.service_details?.description,
                    imageSrc: d?.service_details?.image_src,
                    imageAlt: d?.service_details?.image_alt,
                    linkUrl: d?.service_details?.link_url,
                }));
                setServices(dt);
            }
        });
    }, []);

    return (
        <div className={classNames('flex flex-col gap-y-4 items-center', className)}>
            <div className={'font-extrabold max-w-[500px] text-center text-sm text-primary-green-100 tracking-[0.2em]'}>
                {data?.service?.title}
            </div>
            <div className={'font-bold text-[32px] max-w-[760px] text-center text-primary-green-101 sm:leading-[52px] sm:text-[40px]'}>
                {data?.service?.description}
            </div>
            <div className={'grid gap-10 mt-[44px] md:grid-cols-2 lg:grid-cols-3'}>
                {services.map((service, index) => {
                    const [title1 = "", title2 = ""] = service.title?.split('|') || [];
                    const [desc1 = "", desc2 = ""] = service.description?.split('|') || [];

                    return (
                        <div key={index} className={'bg-white flex flex-col p-6 sm:p-10 rounded-xl gap-y-6'}>
                            <img src={service.imageSrc}  alt={service.imageAlt} className={'h-[80px] mb-4 w-[80px]'}/>
                            <div className={'max-w-[318px]'}>
                                <p className={'font-bold sm:leading-7 text-sm sm:text-base text-primary-green-101'}>{title1}</p>
                                <p className={'text-sm sm:leading-7 sm:text-base text-primary-gray-100'}>{desc1}</p>
                            </div>
                            <div className={'max-w-[318px]'}>
                                <p className={'font-bold text-sm sm:leading-7 sm:text-base text-primary-green-101'}>{title2}</p>
                                <p className={'text-sm sm:leading-7 sm:text-base text-primary-gray-100'}>{desc2}</p>
                            </div>
                            <Button
                                className={
                                    'mt-4 text-base leading-6 w-full'
                                }
                                type="a"
                                href={service.linkUrl}
                                target="_blank"
                            >
                                Coba Gratis!
                            </Button>
                        </div>
                    )}
                )}
            </div>
        </div>
    );
}
